import { Component, inject, OnInit } from '@angular/core';
import { OauthService } from './services/auth/oauth.service';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import { PlaceholderComponent } from './shared/ui-components/placeholder/placeholder.component';
import { FooterComponent } from './shared/ui-components/footer/footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, PlaceholderComponent, FooterComponent],
  standalone: true
})
export class AppComponent implements OnInit {
  public routeLoaded = false;

  private authService = inject(OauthService);
  private router = inject(Router);
  private titleService = inject(Title);

  constructor() {
    this.authService.runInitialLoginSequence().subscribe({
      error(e) {
        // Fatal error encountered when initializing OAuth. App needs to handle this
        console.error(`Error encountered on runInitialLoginSequence`, e);
      }
    });
  }

  appTitle = 'DeakinSync';

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['title']) {
            routeTitle = route!.snapshot.data['title'];
          }
          return routeTitle;
        })
      )
      .subscribe((pageTitle: string) => {
        if (pageTitle) {
          this.titleService.setTitle(`${this.appTitle} | ${pageTitle}`);
        }
      });
  }

  onActivate() {
    this.routeLoaded = true;
  }
}
